export default "__VITE_ASSET__Cqei11IQ__"